// src/pages/GraphicDesigning.tsx
import React from 'react';
import { Link } from 'react-router-dom';
import SEO from "../components/SEO";
import { seoConfig } from "../seoConfig";


import { useImageParallax } from "../hooks/useImageParallax";


import GetInTouch from '../components/GetInTouch';

import graphic from '../assets/images/services/graphic.webp';



const GraphicDesigning: React.FC = () => {


const seo = seoConfig.graphicDesigning; // ✅ Load meta for this page

useImageParallax(".anim-image-parallax"); // hook call


  return (


<>

      <SEO
        title={seo.title}
        description={seo.description}
        keywords={seo.keywords}
        url={seo.url}
        image={seo.image}
      />



  {/* rts bread crumba rea start */}
  <div className="rts-breadcrumb-area-graphic bg_image">
    <div className="container">
      <div className="row">
        <div className="col-lg-12">
          <div className="baread-crumb-main-wrapper pt--100">
            <div className="inner">
              <h1 className="title rts_hero__title">Graphic Designing</h1>
              <span className="bg-text d-none d-md-inline">Manikarn Digital</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  {/* rts bread crumba rea end */}

  {/* rts about area three */}
  <div
    className="rts-about-area parallax-about pt_sm--0 pb--80"
    id="about"
  >
    <div className="container">
      <div className="row g-5 align-items-center">
        <div className="col-lg-5">
          <a href="about.html" className="pli-image-link">
            <div className="pli-image-holder">
              {/* Use class "cover-opacity-*" to set image overlay if needed. For example "cover-opacity-2". Useful if class "pli-info-overlay" is enabled on "portfolio-list". Note: It is individual and depends on the image you use. More info about helper classes in file "helper.css". */}
              <figure className="pli-image">
                <img
                  className="anim-image-parallax tt-lazy"
                  src={graphic}
                  data-src={graphic}
                  alt="image"
                />
              </figure>{" "}
              {/* /.pli-image */}
            </div>{" "}
            {/* /.pli-image-holder */}
          </a>{" "}
          {/* /.pli-image-link */}
        </div>
        <div className="col-lg-7">

  <div className="content-wrapper">
    <span className="sub-title">MANIKARN DIGITAL</span>
    <h2 className="title mt--15 mb--20 mt_sm--10 mb_sm--10">
      Unleash Your Brand’s Visual Identity
    </h2>
    <p className="disc">
      At  <strong>Manikarn Digital</strong>, we elevate your brand through <strong>creative graphic design</strong> that communicates, captivates, and converts. From logos and brand identities to marketing collaterals and social media graphics, our design expertise helps you stand out with consistent, on-brand visuals.
    </p>
    <Link to="/contact" className="learn-more-btn mt--30">
      Contact Us <i className="fa-solid fa-arrow-up-right-from-square"></i>
    </Link>
  </div>


        </div>
      </div>
    </div>
  </div>
  {/* rts about area three end */}

    {/* service area start */}
  <div className="rts-servicearea-start pt_sm--0 pb--100 pb_sm--20">
    <div className="container">
      <div className="row mb--10">
        <div className="col-lg-8 mx-auto">

  <div className="content-wrapper text-center">
    <span className="sub-title">MANIKARN DIGITAL</span>
    <h2 className="title mt--15 mb--20 mt_sm--10 mb_sm--10">
      Transforming Ideas into Stunning Designs
    </h2>
  </div>


        </div>
      </div>
      <div className="row g-2">
        <div className="col-lg-3 col-md-6 col-sm-12 col-12">
          {/* single service area start */}
          <div className="single-service-style-seven">
            <div className="icon">

<svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 60 60" fill="none">
  <defs>
    <filter id="glow-brand" x="-50%" y="-50%" width="200%" height="200%">
      <feGaussianBlur stdDeviation="1.5" result="b"/>
      <feMerge><feMergeNode in="b"/><feMergeNode in="SourceGraphic"/></feMerge>
    </filter>
  </defs>
  <g stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" filter="url(#glow-brand)">

    <path d="M30 8 L45 14 V26c0 10-7 18-15 22C22 44 15 36 15 26V14Z"
          fill="none" stroke-dasharray="160" stroke-dashoffset="160">
      <animate attributeName="stroke-dashoffset" values="160;0;160" dur="4.2s" repeatCount="indefinite"/>
    </path>


    <path d="M30 19 l6 10 -6 12 -6-12 6-10 Z" fill="none" />
    <circle cx="30" cy="31" r="1.8" fill="currentColor">
      <animate attributeName="r" values="1.8;3;1.8" dur="1.6s" repeatCount="indefinite"/>
      <animate attributeName="opacity" values="1;0.5;1" dur="1.6s" repeatCount="indefinite"/>
    </circle>


    <g>
      <circle cx="30" cy="12" r="2" fill="currentColor" opacity="0.4"/>
      <animateTransform attributeName="transform" type="rotate" values="0 30 30;360 30 30" dur="3.6s" repeatCount="indefinite"/>
    </g>
  </g>
</svg>




            </div>
            <h5 className="title-1">
              Logo & Brand<br/>Identity
            </h5>
            <p className="disc">
              We craft memorable logos and visual systems that reflect your brand's values, build recognition, and leave a lasting impression with thoughtful typography, colors, and symbolism.
            </p>
          </div>
          {/* single service area end */}
        </div>
        <div className="col-lg-3 col-md-6 col-sm-12 col-12">
          {/* single service area start */}
          <div className="single-service-style-seven">
            <div className="icon">

<svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 60 60" fill="none">
  <g stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">

    <polygon points="12,24 30,16 48,24 48,42 30,50 12,42" fill="none" stroke-dasharray="220" stroke-dashoffset="220">
      <animate attributeName="stroke-dashoffset" values="220;0;220" dur="4.5s" repeatCount="indefinite"/>
    </polygon>


    <g>
      <polygon points="12,24 30,16 48,24 30,32" fill="none"/>
      <animateTransform attributeName="transform" type="rotate" values="0 30 24; -12 30 24; 0 30 24"
                        dur="2.8s" repeatCount="indefinite"/>
    </g>


    <rect x="24" y="32" width="12" height="6" rx="1.5" fill="currentColor" opacity="0.4">
      <animate attributeName="x" values="22;24;22" dur="1.8s" repeatCount="indefinite"/>
      <animate attributeName="opacity" values="0.4;0.9;0.4" dur="1.8s" repeatCount="indefinite"/>
    </rect>
  </g>
</svg>





            </div>
            <h5 className="title-1">
              Print & Packaging<br/>Design
            </h5>
            <p className="disc">
              From brochures and menus to labels and packaging, we design tactile brand touchpoints that draw attention and communicate quality - all aligned with your brand essence.
            </p>

          </div>
          {/* single service area end */}
        </div>
        <div className="col-lg-3 col-md-6 col-sm-12 col-12">
          {/* single service area start */}
          <div className="single-service-style-seven">
            <div className="icon">


<svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 60 60" fill="none">
  <g stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">

    <path d="M14 18 h24 a8 8 0 0 1 8 8 v6 a8 8 0 0 1-8 8 H26 l-8 6 v-6 h-4 a8 8 0 0 1-8-8 v-6 a8 8 0 0 1 8-8Z"
          fill="none" stroke-dasharray="200" stroke-dashoffset="200">
      <animate attributeName="stroke-dashoffset" values="200;0;200" dur="4.4s" repeatCount="indefinite"/>
    </path>

 
    <polygon points="26,26 34,30 26,34" fill="currentColor" opacity="0.5">
      <animateTransform attributeName="transform" type="scale" values="1;1.15;1" dur="1.6s" repeatCount="indefinite"/>
    </polygon>


    <g opacity="0.4">
      <circle cx="42" cy="24" r="1" stroke="currentColor" fill="none">
        <animate attributeName="r" values="1;8" dur="1.6s" repeatCount="indefinite"/>
        <animate attributeName="opacity" values="0.9;0" dur="1.6s" repeatCount="indefinite"/>
      </circle>
      <circle cx="42" cy="24" r="1" stroke="currentColor" fill="none">
        <animate attributeName="r" values="1;8" dur="1.6s" begin="0.4s" repeatCount="indefinite"/>
        <animate attributeName="opacity" values="0.9;0" dur="1.6s" begin="0.4s" repeatCount="indefinite"/>
      </circle>
    </g>


    <circle cx="46" cy="18" r="2.4" fill="currentColor">
      <animate attributeName="r" values="2.4;3.6;2.4" dur="1.2s" repeatCount="indefinite"/>
      <animate attributeName="opacity" values="1;0.5;1" dur="1.2s" repeatCount="indefinite"/>
    </circle>
  </g>
</svg>





            </div>
            <h5 className="title-1">
              Digital & Social<br/>Media Graphics
            </h5>
            <p className="disc">
              We design eye-catching social posts, ads, banners, and infographics optimized for both aesthetics and engagement - designed to boost visibility and resonate with your audience.
            </p>
          </div>
          {/* single service area end */}
        </div>
                <div className="col-lg-3 col-md-6 col-sm-12 col-12">
          {/* single service area start */}
          <div className="single-service-style-seven">
            <div className="icon">


<svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 60 60" fill="none">
  <g stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" fill="none">

    <path d="M18 40 a14 12 0 1 1 24 -18 a4 4 0 1 0 -5 5" stroke-dasharray="140" stroke-dashoffset="140">
      <animate attributeName="stroke-dashoffset" from="140" to="0" dur="2s" repeatCount="indefinite"/>
    </path>

    <circle cx="24" cy="30" r="2.2" fill="white" opacity="0.4">
      <animate attributeName="r" values="2.2;3.8;2.2" dur="2s" repeatCount="indefinite"/>
    </circle>
    <circle cx="34" cy="22" r="1.8" fill="white" opacity="0.4">
      <animate attributeName="r" values="1.8;3;1.8" dur="2.2s" begin="2.5s" repeatCount="indefinite"/>
    </circle>

    <path d="M45 42 q-10 -6 -22 -6" stroke="white" stroke-width="1.5" fill="none" stroke-dasharray="60" stroke-dashoffset="60">
      <animate attributeName="stroke-dashoffset" from="60" to="0" dur="2.10s" begin="0.15s" repeatCount="indefinite"/>
      <animateTransform attributeName="transform" type="translate" values="0 0;0 1;0 0" dur="2s" repeatCount="indefinite"/>
    </path>
  </g>
</svg>



            </div>
            <h5 className="title-1">
              Illustration & Custom<br/>Visuals
            </h5>
            <p className="disc">
              Our team creates original illustrations and visuals that enhance storytelling and elevate brand messaging - perfect for books, blogs, campaigns, and presentations.
            </p>
          </div>
          {/* single service area end */}
        </div>
      </div>
    </div>
  </div>
  {/* service area ends */}





{/* ==== GetInTouch Section start ==== */}
<GetInTouch />
{/* ==== / GetInTouch Section end ==== */}  




</>    



  );
};

export default GraphicDesigning;
